module.exports = __webpack_public_path__ + "static/media/gb-nir.9cad35c4.svg";